import type { UserDto } from '../schemas/authSchemas';

// Single source of truth for "where does this user land after auth".
// Centralised so /login, /signup, RootRedirect, and the post-onboarding
// "Finish Up" all fall back to the same rule.
//
// Order of precedence:
//   1. SuperAdmin               -> /admin (no onboarding, no tenant)
//   2. Onboarding incomplete    -> /onboarding/personal-details (resume)
//        Catches fresh signups (no tenantId yet -- tenant is created in
//        Step 2 of the Organization branch) AND returning users who
//        closed the tab mid-flow. The check runs before tenantId so a
//        tenant-less just-signed-up user doesn't fall through to /login.
//   3. Completed user           -> /dashboard
//   4. Tenant-less, completed   -> /dashboard
export function postAuthLanding(user: UserDto): string {
  if (user.isSuperAdmin) {
    return '/admin';
  }
  if (!user.onboardingCompleted) {
    return '/onboarding/your-details';
  }
  return '/dashboard';
}
